var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextArea',{attrs:{"value":_vm.singleValue},on:{"input":function($event){return _vm.emitSingleValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }